import { render, staticRenderFns } from "./AppHighlightedText.vue?vue&type=template&id=08330d1a&scoped=true&"
import script from "./AppHighlightedText.vue?vue&type=script&lang=js&"
export * from "./AppHighlightedText.vue?vue&type=script&lang=js&"
import style0 from "./AppHighlightedText.vue?vue&type=style&index=0&id=08330d1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08330d1a",
  null
  
)

export default component.exports